<template>
  <v-container fluid class="container pa-0">
    <v-carousel
      hide-delimiter-background
      show-arrows-on-hover
      cycle
      height="857"
      :show-arrows="!$vuetify.breakpoint.smAndDown"
      class="carousel-item header tear-1"
      v-model="model"
    >
      <div class="wave">
        <svg
          data-name="Layer 1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1200 120"
          preserveAspectRatio="none"
        >
          <path
            d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z"
            class="shape-fill"
          />
        </svg>
      </div>

      <v-carousel-item v-for="(slide, i) in slides" :key="slide.color">
        <v-row
          class="fill-height ma-0 align-sm-center align-md-center align-lg-center align-xl-center justify-sm-center justify-md-center justify-lg-center justify-xl-center align-start justify-start"
          style="width:100%; position:relative "
        >
          <v-col
            class="card-wrapper col-sm-9 col-md-6 col-lg-6 col-xl-6 order-md-first order-lg-first order-xl-first col-12 order-last"
          >
            <div class="slider-card pa-5 leftInfoSlider">
              <h1 class="white--text mobile-h3 carousel-title">
                {{ slide.title }}
              </h1>

              <p class="body slider-description " v-html="slide.description" />
              <button
                v-if="slide.link.length > 0"
                class="cta read-more yellow-fill notranslate"
                @click="goToLink(slide.link)"
              >
                {{ $t("leerMas") }}
              </button>
            </div>
          </v-col>
          <v-col cols="8" sm="9" md="6" lg="6" xl="6" class="image-container">
            <v-img
              cover
              class="slider-image mr-5"
              :aspect-ratio="1 / 1"
              :src="sliderPath + slide.image"
              max-height="590px"
              max-width="590px"
            />
          </v-col>
        </v-row>
      </v-carousel-item>
      <div class="curve">
        <svg
          data-name="Layer 1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1200 120"
          preserveAspectRatio="none"
        >
          <path
            d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z"
            class="shape-fill"
          ></path>
        </svg>
      </div>
    </v-carousel>

    <v-container fluid class="px-5" style="height:auto !important; ">
      <v-row class="justify-center mt-10">
        <v-col cols="10">
          <h3 data-aos="fade-right" class="h2-alt notranslate">{{ $t("seminarios.title") }}</h3>
          <p data-aos="fade-top" class="body notranslate" style="max-width:350px">
            {{ $t("seminarios.subtitle") }}
          </p>
        </v-col>

        <v-col
          cols="12"
          xs="12"
          sm="12"
          style="margin-bottom:100px; max-width:1200px "
          :class="imageShouldShow('mdAndUp') ? 'px-15' : null"
        >
          <v-row
            justify="center"
            justify-sm="center"
            justify-md="center"
            justify-xl="center"
            justify-lg="center"
            class="mt-0"
          >
            <v-col
              class="mt-3 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12"
              v-for="(item, index) in seminarios"
              :key="item.name"
              style="max-width:400px !important"
            >
              <SeminariosCell :seminar="item" :index="index" />
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <!-- <v-row class="justify-center noticias">
        <v-col
          cols="12"
          style="margin-bottom:150px"
          :class="imageShouldShow('mdAndUp') ? 'px-15' : null"
        >
          <v-row
            class="mt-8 justify-sm-start justify-md-start justify-lg-center justify-xl-center justify-start"
          >
            <v-col cols="12" md="2" lg="2" xl="2" style="max-width:183px">
              <h3 data-aos="fade-right" class="notranslate">{{ $t("noticias") }}</h3>
            </v-col>
            <v-col cols="12" md="9" lg="9" xl="9">
              <el-tabs
                data-aos="fade-left"
                v-if="years[0].name != '2001'"
                v-model="selectedYear.name"
              >
                <el-tab-pane
                  v-for="(year, index) in years"
                  :key="index"
                  :label="year.name + ''"
                  :name="year.name + '' + index"
                >
                  <el-tabs :value="year.activeNew">
                    <el-tab-pane
                      v-for="month in year.months"
                      :key="month.value + year.name"
                      :label="month.name"
                      :name="month.name"
                      :style="'opacity:' + !month.disabled ? '1' : '.3 !impotant'"
                      :disabled="month.disabled"
                    >
                      <v-expansion-panels
                        accordion
                        flat
                        :value="0"
                        class="mt-15"
                        style="border-top:2px black solid; border-radius:0px"
                      >
                        <v-expansion-panel
                          v-for="(noticia, i) in getNewsFromDate(
                            parseInt(month.value) + 1,
                            year.name
                          )"
                          :key="i"
                        >
                          <v-expansion-panel-header>
                            <h3>{{ noticia.title }}</h3>
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <v-row>
                              <v-col class="body mid-grey" cols="12" md="8" lg="8" xl="8">
                                <div v-html="noticia.content" />
                                <br />
                                <button
                                  class=" links underline notranslate"
                                  @click="setNoticia(noticia)"
                                >
                                  {{ $t("leerMas") }}
                                </button>
                              </v-col>
                              <v-col cols="12" md="4" lg="4" xl="4">
                                <v-img
                                  :src="newsPath + noticia.image"
                                  width="80%"
                                  max-height="250px"
                                  class="noticia-image"
                                  :aspect-ratio="1"
                                />
                                <span class="body-2 grey-2">
                                  {{ new Date(noticia.date).toLocaleDateString() }}
                                </span>
                                <p class="tag grey-2">{{ noticia.tag }}</p>
                              </v-col>
                            </v-row>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </el-tab-pane>
                  </el-tabs>
                </el-tab-pane>
              </el-tabs>
            </v-col>
          </v-row>
        </v-col>
      </v-row> -->

      <v-row class="revista-oceanologia" justify="center">
        <v-col
          class="col-md-6 col-lg-6 col-xl-6 col-10 d-flex flex-column align-start"
          data-aos="fade-right"
        >
          <div class="magazine-card">
            <div class="covers-wrapper">
              <v-img src="../assets/images/cover-1.jpeg" class="grey lighten-2 covers cover-1">
                <template v-slot:placeholder>
                  <v-row class="fill-height ma-0" align="center" justify="center">
                    <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
              <v-img src="../assets/images/cover-2.jpeg" class="grey lighten-2 covers cover-2">
                <template v-slot:placeholder>
                  <v-row class="fill-height ma-0" align="center" justify="center">
                    <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
              <v-img src="../assets/images/cover-3.jpeg" class="grey lighten-2 covers cover-3">
                <template v-slot:placeholder>
                  <v-row class="fill-height ma-0" align="center" justify="center">
                    <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </div>
            <h2 class="magazine-title mt-3 h2-alt notranslate">{{ $t(`revista.title`) }}</h2>
            <p class="body notranslate">{{ $t(`revista.content`) }}</p>
            <button class=" cta read-more  notranslate" @click="openMagazine()">
              {{ $t("leerMas") }}
            </button>
          </div>
        </v-col>
        <v-col
          data-aos="fade-left"
          class="col-md-6 col-lg-6 col-xl-6 col-10 d-flex flex-column d-flex flex-column align-start"
        >
          <div class="podcast-wrapper">
            <v-img :src="podcast" class="podcast-image"> </v-img>
            <h2 class="magazine-title mt-3 h2-alt" style="max-width:362px; height:80px !important">
              Radar Oceanográfico
            </h2>
            <p class="body notranslate" style="max-width:697px">{{ $t(`radarOceanografico`) }}</p>
            <button class=" cta read-more white--text notranslate" @click="openPodcast()">
              {{ $t("leerMas") }}
            </button>
          </div>
        </v-col>
      </v-row>

      <v-row class="justify-center mt-10">
        <!-- <v-col cols="10">
          <h3 data-aos="fade-right" class="h2-alt notranslate">{{ $t("stations.title") }}</h3>
          <p data-aos="fade-top" class="body notranslate" style="max-width:250px">
            {{ $t("stations.subtitle") }}
          </p>
        </v-col> -->

        <v-col cols="11" md="10" lg="10" xl="10" style="margin-bottom:100px; max-width:1400px ">
          <v-row justify="center" class="mt-2 d-flex flex-row-reverse">
            <v-col cols="11" md="7" class="pl-2">
              <!-- infografia card -->
              <v-card
                class="infografia-card pa-0 elevation-0"
                :class="$vuetify.breakpoint.smAndDown ? 'col-12' : ''"
                data-aos="fade-left"
              >
                <v-img
                  :src="require(`../assets/images/letrero_Infografias.jpeg`)"
                  position="top center"
                  class="grey lighten-2"
                  :aspect-ratio="1"
                  style="height: 300px;"
                >
                </v-img>
                <div class="infografias-info">
                  <h2 class="magazine-title mt-3 h2-alt">{{ $t("infografias.title") }}</h2>
                  <p class="body notranslate" v-html="$t('infografias.content')"></p>
                  <router-link class="white--text" to="/infografias">
                    <button class=" cta read-more  notranslate">
                      {{ $t("leerMas") }}
                    </button>
                  </router-link>
                </div>
              </v-card>
              <!-- <iframe
                :src="firstAirQualityLocation"
                width="100%"
                height="485"
                frameborder="0"
                scrolling="no"
              ></iframe> -->
            </v-col>

            <v-col md="5" cols="11" class="d-flex flex-column align-center">
              <iframe
                data-aos="fade-right"
                :src="firstWeatherLocation"
                width="340"
                height="495"
                scrolling="no"
                frameborder="0"
              ></iframe>
              <div>
                <h3 data-aos="fade-right" class="h2-alt notranslate">{{ $t("stations.title") }}</h3>
                <p data-aos="fade-top" class="body notranslate" style="max-width:250px">
                  {{ $t("stations.subtitle") }}
                </p>
                <router-link class="white--text" to="/estaciones-meteorologicas">
                  <button class=" cta read-more  notranslate">
                    {{ $t("leerMas") }}
                  </button>
                </router-link>
              </div>
            </v-col>

            <!-- <div class="stations-bottom" data-aos="fade-up">
              <router-link class="ver-mas" to="/estaciones-meteorologicas">
                ver más<v-icon v-html="'mdi-chevron-right'" />
              </router-link>
            </div> -->
          </v-row>
        </v-col>
      </v-row>

      <v-row class="galeria" align="center" v-if="images_urls">
        <v-col cols="12" xl="3" lg="3" md="3" sm="6">
          <h2 class="h2-alt notranslate">{{ $t("galeria.title") }}</h2>
          <p class="body notranslate" style="max-width:220px">{{ $t("galeria.content") }}</p>
        </v-col>

        <v-col
          cols="12"
          xl="3"
          lg="3"
          md="3"
          sm="6"
          class="pa-0 gallery-cell"
          :data-aos-delay="Math.floor(Math.random() * 100)"
          data-aos="zoom-in"
          v-on:click="imageIndex = 0"
        >
          <v-img class="galery-item" :src="gallery[0]" height="250" />
        </v-col>
        <v-col
          v-if="imageShouldShow('mdAndUp')"
          class="pa-0 gallery-cell"
          :data-aos-delay="Math.floor(Math.random() * 100)"
          data-aos="zoom-in"
          cols="6"
          v-on:click="imageIndex = 1"
        >
          <v-img class="galery-item" :src="gallery[1]" height="250" />
        </v-col>
        <v-col
          cols="12"
          xl="6"
          lg="6"
          md="6"
          sm="6"
          class="pa-0 gallery-cell"
          :data-aos-delay="Math.floor(Math.random() * 100)"
          data-aos="fade-right"
          v-on:click="imageIndex = 2"
        >
          <v-img class="galery-item" :src="gallery[2]" height="250" />
        </v-col>
        <v-col
          v-if="imageShouldShow('smAndUp')"
          class="pa-0 gallery-cell"
          :data-aos-delay="Math.floor(Math.random() * 100)"
          data-aos="fade-left"
          cols="6"
          v-on:click="imageIndex = 3"
        >
          <v-img class="galery-item" :src="gallery[3]" height="250" />
        </v-col>
        <v-col
          cols="12"
          xl="4"
          lg="4"
          md="4"
          sm="6"
          class="pa-0 gallery-cell"
          :data-aos-delay="Math.floor(Math.random() * 100)"
          data-aos="fade-right"
          v-on:click="imageIndex = 4"
        >
          <v-img height="250" class="galery-item" :src="gallery[4]" />
        </v-col>
        <v-col
          v-if="imageShouldShow('mdAndUp')"
          class="pa-0 gallery-cell"
          :data-aos-delay="Math.floor(Math.random() * 100)"
          data-aos="fade-up"
          cols="4"
          v-on:click="imageIndex = 5"
        >
          <v-img height="250" class="galery-item" :src="gallery[5]" />
        </v-col>
        <v-col
          cols="4"
          lg="4"
          md="4"
          sm="6"
          v-if="imageShouldShow('smAndUp')"
          class="pa-0 gallery-cell"
          :data-aos-delay="Math.floor(Math.random() * 100)"
          data-aos="fade-left"
          v-on:click="imageIndex = 6"
        >
          <v-img height="250" class="galery-item" :src="gallery[6]" />
        </v-col>
      </v-row>

      <ScrollToTop />
      <ChangeLang />
      <ScrollDown />
      <ModalNews :noticia="noticia" :dialog="showNoticia" :close="() => (showNoticia = false)" />
      <LightGallery
        :images="gallery"
        :index="imageIndex"
        :disable-scroll="true"
        @close="imageIndex = null"
      />
    </v-container>
  </v-container>
</template>

<script>
import $ from "jquery";
import { LightGallery } from "vue-light-gallery";
import LottieAnimation from "lottie-vuejs/src/LottieAnimation.vue";
//{v-container, v-row, v-col, v-img, v-expansion-panels, v-expansion-panel, v-expansion-panel-header, v-expansion-panel-content, v-carousel, v-carousel-item }

export default {
  name: "Home",
  components: {
    ModalNews: () => import(/* webpackPrefetch: true */ "../components/Modals/News.vue"),
    SeminariosCell: () =>
      import(/* webpackPrefetch: true */ "../components/Lists/SeminariosCell.vue"),
    ScrollToTop: () => import(/* webpackPrefetch: true */ "../components/Form/scrollToTop.vue"),
    ScrollDown: () => import(/* webpackPregetch: true */ "../components/Form/scrollDown.vue"),
    ChangeLang: () => import(/* webpackPrefetch: true */ "../components/Form/changeLang.vue"),
    LottieAnimation,
    LightGallery
  },
  computed: {
    podcast: () => require("../assets/images/uabc_radio_radar_1.jpeg"),
    galleryPath: () => $(location).attr("origin") + "/archivos/galeria/",
    infografiasPath: () => $(location).attr("origin") + "/archivos/infografias/",
    sliderPath: () => $(location).attr("origin") + "/archivos/slider/",
    newsPath: () => $(location).attr("origin") + "/archivos/noticias/",
    gallery() {
      if (this.images_urls) {
        return this.images_urls.map(image => {
          image = this.galleryPath + image;
          return image;
        });
      }
    },
    firstWeatherLocation() {
      return this.$info.estaciones.estacionesMeteorologicas.locations[0].url;
    },
    firstAirQualityLocation() {
      return this.$info.estaciones.calidadDelAire.urls[0];
    },
    // async lastInfografia() {
    //   let infografias;
    //   new Promise(done =>
    //     $.getJSON(this.infografiasPath, async function(data) {
    //       infografias = data;
    //       done();
    //     })
    //   );
    //   if (infografias) {
    //     const infografias_list = this.infografias.map(image => {
    //       image = this.infografiasPath + image;
    //       return image;
    //     });
    //     return infografias_list[infografias_list.length - 1];
    //   }
    // },
    seminarios() {
      console.warn(this.$info);
      return [...this.$info.seminarios];
    },
    getNewsYears() {
      const { noticias } = this.$info.home;
      const year_list = [
        ...new Set(
          noticias.map(news => {
            return new Date(news.date).getFullYear();
          })
        )
      ];

      this.years = year_list.map(year => {
        const formatedYear = { name: year };
        formatedYear.months = [
          { name: "Enero", value: "0" },
          { name: "Febrero", value: "1" },
          { name: "Marzo", value: "2" },
          { name: "Abril", value: "3" },
          { name: "Mayo", value: "4" },
          { name: "Junio", value: "5" },
          { name: "Julio", value: "6" },
          { name: "Agosto", value: "7" },
          { name: "Septiembre", value: "8" },
          { name: "Octubre", value: "9" },
          { name: "Noviembre", value: "10" },
          { name: "Diciembre", value: "11" }
        ];
        var activeNew = null;
        formatedYear.months.forEach((month, i) => {
          const isEneable = this.getNewsFromDate(parseInt(month.value) + 1, year).length > 0;
          month.disabled = !isEneable;
          if (isEneable) activeNew = month.name;
        });
        formatedYear.activeNew = activeNew;

        return formatedYear;
      });
      console.warn(this.years);
      this.years.reverse();
    }
  },
  methods: {
    setNoticia(noticia) {
      this.noticia = noticia;
      this.showNoticia = true;
    },
    goToLink(link) {
      try {
        const url = JSON.parse(link);
        this.$router.push({ path: url.route });
      } catch (e) {
        window.open(link);
      }
    },
    async lastInfografia() {
      $.getJSON(this.infografiasPath, infografias => {
        if (!infografias) return;
        const infografias_list = infografias.map(image => {
          return this.infografiasPath + image;
        });
        this.infografia = infografias_list[infografias_list.length - 1];
      });
    },
    openPodcast() {
      window.open("http://radio.uabc.mx/radar-oceanografico");
    },
    openMagazine() {
      window.open("https://cienciasmarinas.com.mx/index.php/cmarinas");
    },
    imageShouldShow(height) {
      return this.$vuetify.breakpoint[height];
    },
    getNewsFromDate(month, year) {
      const { noticias } = this.$info.home;
      var news_from_date = [];
      noticias.forEach((noticia, i) => {
        const date = new Date(noticia.date);
        if (`${date.getFullYear()}/${date.getMonth() + 1}` == `${year}/${month}`) {
          news_from_date.push(noticia);
        }
      });
      news_from_date = news_from_date.sort((a, b) => {
        const aDate = new Date(a.date);
        const bDate = new Date(b.date);
        if (aDate < bDate) return 1;
        if (aDate > bDate) return -1;
        return 0;
      });

      return news_from_date;
    }
  },
  beforeMount: function() {
    this.slides = [...this.$info.home.slider.map(slide => slide)];
    this.getNewsYears;
    $.getJSON(this.galleryPath, data => {
      this.images_urls = data;
    });

    this.selectedYear = { name: this.years[0].name + "0" };
    this.lastInfografia();
  },
  data: () => ({
    model: 0,
    slides: null,
    activeName: "",
    panels: [],
    selectedYear: "",
    years: [{ name: "2001" }],
    months: [
      { name: "Enero", value: "0" },
      { name: "Febrero", value: "1" },
      { name: "Marzo", value: "2" },
      { name: "Abril", value: "3" },
      { name: "Mayo", value: "4" },
      { name: "Junio", value: "5" },
      { name: "Julio", value: "6" },
      { name: "Agosto", value: "7" },
      { name: "Septiembre", value: "8" },
      { name: "Octubre", value: "9" },
      { name: "Noviembre", value: "10" },
      { name: "Diciembre", value: "11" }
    ],
    monthEneable: null,
    images_urls: null,
    infografia: null,
    imageIndex: null,
    noticia: null,
    showNoticia: false
  })
};
</script>
<style lang="scss" scoped>
@import "@/assets/styles/global";
.container {
  height: 100%;
  overflow: hidden;
}
// .noticia-image {
//   border-radius: 5px;
//   margin-left: auto;
//   margin-right: auto;
//   margin-bottom: 10px;
//   border: 1px solid rgba(0, 0, 0, 0.1);
// }
.wave {
  position: absolute;
  bottom: 0px;
  left: -1px;
  width: 100%;
  overflow: hidden;
  line-height: 0;
}

.wether-stations {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 15px;
  .read-more {
    position: relative !important;
    width: 139px !important;
    height: 39px !important;
    border-radius: 72px !important;
    margin-left: auto;
    right: 0px;
  }
}
.infografias-info {
  display: flex;
  margin: 10px 5px;
  flex-direction: column;
  justify-content: space-between;
}

.stations-bottom {
  display: flex;
  justify-content: flex-end;
  width: 100%;
  margin-top: 20px;
  // border-top: 1px #bbb solid;
  // padding-top: 24px;
  padding-right: 22px;
  .ver-mas {
    font-family: Poppins;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 28px;
    color: #383838;
    i {
      padding-left: 15px;
    }
  }
}

.wave svg {
  position: relative;
  display: block;
  width: calc(150% + 1.3px);
  height: 278px;
  stroke: #646464;
  stroke-width: 1px;
  stroke-linejoin: round;
}

.wave .shape-fill {
  fill: transparent;
}

.carousel-item {
  position: relative;
}
.card-wrapper {
  display: flex;
  justify-content: flex-end;
}
.slider-card {
  max-width: 480px;
  margin-top: -100px;
  display: flex;
  flex-direction: column;
}
.image-container {
  display: flex;
}

.slider-image {
  border-radius: 50%;
  float: left;
  z-index: 1;
}
.slider-description {
  margin-top: 20px;
  color: white;
  max-width: 400px;
  width: auto;
  text-overflow: ellipsis;
  overflow: hidden;
  // Addition lines for 2 line or multiline ellipsis
  display: -webkit-box !important;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  white-space: normal;
}
.leftInfoSlider {
  position: relative;
  padding-right: 30px;
}

.magazine-card {
  margin: 0 auto;
  max-width: 490px;
}

.magazine-title {
  display: flex;
  align-items: center;
  // max-width: 287px;
  height: 80px;
}

.covers-wrapper {
  position: relative;
  max-width: 490px;
  height: 352px;
}
.covers {
  // transform: rotate(8deg);
  width: 262px;
  position: absolute;
}
.cover-1 {
  left: 0%;
}
.cover-2 {
  left: 22%;
}
.cover-2::after {
  display: block;
  position: absolute;
  background-image: linear-gradient(270deg, rgba(0, 0, 0, 0.4802) 0%, rgba(0, 0, 0, 0) 91.43%);
  height: 100%;
  margin-left: 45px;
  width: 73px;
  content: "";
}
.cover-3 {
  left: 45%;
}
.cover-1::after {
  display: block;
  position: absolute;
  background-image: linear-gradient(270deg, rgba(0, 0, 0, 0.4802) 0%, rgba(0, 0, 0, 0) 91.43%);
  margin-left: 45px;
  height: 100%;
  width: 73px;
  content: "";
}
.podcast-wrapper {
  max-width: 100%;
  position: relative;
  .podcast-image {
    max-height: 449px;
    max-width: 697px;
  }
}
.galeria {
  padding-top: 90px !important;
  padding: 0 10%;
  .gallery-cell {
    overflow: hidden;
  }
  .galery-item {
    transition: all 0.3s ease-out;
  }
  .galery-item::after {
    position: absolute;
    display: block;
    background-color: rgba(0, 0, 0, 0.4);
    height: 100%;
    width: 100%;
    opacity: 0;
    content: "";
  }

  .galery-item:hover {
    transform: scale(1.1);
    &::after {
      opacity: 1;
    }
  }
}

@media only screen and (max-width: $screen-lg-min) {
  .slider-card {
    margin-top: -0px !important;
    height: 400px;
  }
  .card-wrapper {
    justify-content: center;
  }
  .image-container {
    margin-top: 60px;
    height: 350px !important;
    width: 350px !important;
    max-height: 350px !important;
    max-width: 350px !important;
    * {
      height: 326px !important;
      width: 326px !important;
      max-height: 326px !important;
      max-width: 326px !important;
    }
  }
}
@media (max-width: 600px) {
  .card-wrapper {
    // align-self: flex-start;
    // justify-content: flex-start !important;
  }
}

@media (max-width: $screen-lg-min) and (min-width: 500px) {
  .slider-card {
    top: -50px !important;
  }
}

@media (max-width: 500px) {
  .slider-card {
    padding-top: 0px !important;
  }
  .carousel-title {
    margin-top: 30px;
  }
  .slider-description {
    max-width: 90vw;
  }
  .card-wrapper {
    height: 100%;
    align-self: flex-start;
    justify-content: flex-start !important;
    h1 {
      font-family: Poppins;
      font-style: normal;
      font-weight: bold;
      font-size: 32px;
      line-height: 42px;
    }
  }
  .covers-wrapper {
    margin: 0 auto;
    position: relative;
    align-self: center;
    max-width: 287px;
    height: 204px;
    .covers {
      // transform: rotate(8deg);
      width: 152px;
      height: 204px;
      position: absolute;
    }
  }

  .podcast-image {
    margin: 0 auto;
    max-height: 185px !important;
    max-width: 286px !important;
  }
  .image-container {
    display: flex;
    margin-top: 55px !important;
    margin-left: 30px;
    padding-bottom: 0px;
    align-items: flex-end;
    justify-content: flex-start;
    height: 254px !important;
    width: 254px !important;
    max-height: 254px !important;
    max-width: 254px !important;
    * {
      height: 240px !important;
      width: 240px !important;
      max-height: 240px !important;
      max-width: 240px !important;
    }
  }
}
// 'xs': 0,
// 'sm': 340px,
// 'md': 540px,
// 'lg': 800px - 24px,
// 'xl': 1280px - 24px
</style>
<style lang="scss">
.tear-1 {
  h1 {
    font-size: 38px;
    line-height: 48px;
  }
}
</style>
